
export class Layer {
    map = undefined;
    class = "layer";
    name = "layer";
    dynamic = {
        "time": false,
        "level": false
    };
    source = undefined;
    layer = undefined;
    settings = { 
        "visible": false
    };

    constructor(map, settings = {}){
        this.map = map;
        if( settings.name ){ this.name = settings.name; delete settings.name; }
        if( settings.dynamic_time ){ this.dynamic['time'] = settings.dynamic_time; delete settings.dynamic_time; }
        if( settings.dynamic_level ){ this.dynamic['level'] = settings.dynamic_level; delete settings.dynamic_level; }

        for( let key in settings ){
            this.settings[key] = settings[key];
        }
    }

    get( key ){
        if( key in this.settings )
            return this.settings[key];
        return undefined;
    }

    getState(){
        let state = JSON.parse(localStorage.getItem( this.map.getAppName() + "." + this.name));
        if( state ){
            for( let key in this.settings ){
                if( !(key in state) ) continue;
                this.settings[key] = state[key];
            }
        }
        let search = new URLSearchParams(window.location.search);
        for( let key in this.settings ){
            let val = undefined;
            if( val = search.get(this.name + "." + key)){
                if( typeof this.settings[key] == "boolean" ){
                    if( val == "on" || val == "1" )
                        this.settings[key] = true;
                    else
                        this.settings[key] = false;
                } else 
                    this.settings[key] = val;;
            }

        }
    }

    refresh(){
        console.info( 'refreshing', this.name );
    }

    set( key, val ){
        if( key in this.settings ){
            this.settings[key] = val;
            if( key == "visible" ) this.layer.setVisible(val);
            return 1;
        }
        return 0;
    }

    saveState(){
        localStorage.setItem( map.getAppName() + "." + this.name, JSON.stringify(this.settings));
    }

    setLevel(val){
    }

    setVisible( val ){
        if( val == undefined )
            this.layer.setVisible( this.layer.isVisible()? false: true );
        else
            this.layer.setVisible( val );
        this.settings['visible'] = this.layer.isVisible();
        return this.settings['visible'];
    }

    updateLevel(){
    }

    updateTime(){
    }
}
